
import { defineComponent, PropType } from "vue";
import LogoComponent from "./Logo.vue";

export default defineComponent({
  name: "LogosComponent",
  components: { LogoComponent },

  props: {
    logos: {
      required: true,
      type: Object as PropType<string[]>,
    },
  },
});
